//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Axios from 'axios';
import { Loading, exportFile } from 'quasar';

export default {
    name: 'Download',
    data() {
        return {
            greetings: [],
            infoDialog: false,
            accountBtnEnabled: false,
            errorDialog: false,
        };
    },
    mounted() {
        this.checkSalutation();
    },
    computed: {
        ...mapState(['currency', 'persons', 'accountDetails', 'legal', 'step']),
    },
    methods: {
        checkSalutation() {
            this.persons.forEach((person) => {
                if (person.salutation === 'male') {
                    this.greetings.push(' geehrter Herr ' + person.name + ', ');
                } else {
                    this.greetings.push(' geehrte Frau ' + person.name + ', ');
                }
            });
        },
        async getDownload(){
            Loading.show();

            let formData = {};

            let personCount = 1;
            Object.entries(this.persons).forEach(([_, person]) => {
                Object.entries(person).forEach(([key, val]) => {
                    if(key === 'employmentSituation') {
                        formData['employmentSituation' + personCount] = val.label + ' - ' + val.value;
                    } else {
                        formData[key + personCount] = val;
                    }
                });
                personCount++;
            });

            Object.entries(this.accountDetails).forEach(([key, val]) => {
                formData[key] = val;
            });

            Object.entries(this.legal).forEach(([key, val]) => {
                formData[key] = val;
            });

            formData.currency = this.currency.code;
            formData.interest = this.currency.currencyRate.interest.toLocaleString('de-DE', { minimumFractionDigits: 4 });

            await Axios.post(
                '/api/contract',
                formData,
                {
                    responseType: 'blob',
                },
            ).then((response) => {
                Loading.hide();
                exportFile('VBHL24_STARPLAN_Konto_online.pdf', new Blob([response.data]), 'application/pdf');
                this.accountBtnEnabled = true;
            }).catch((error) => {
                Loading.hide();
                this.errorDialog = true;
            });
        },
        openAccount() {
            let url = '';

            if(this.persons.length > 1) {
                // URL 'Gemeinschaftskonto'
                url = 'https://www.volksbank-luebeck.de/ogs/girokonto-bezahlen/girokonto-fremdwaehrung-g.html';
            } else {
                // URL 'Einzelkonto'
                url = 'https://www.volksbank-luebeck.de/ogs/girokonto-bezahlen/girokonto-fremdwaehrung.html';
            }

            window.top.location.href = url;
        },
        back() {
            this.$store.dispatch('setStep', this.step - 1);
        },
    },
};
